// Lightweight admin auth context for the React app.
// Stores JWT token in localStorage and exposes a helper for protected requests.
import axios from "axios";

const TOKEN_KEY = "btacc_admin_token";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function clearAdminToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function adminApi() {
  const token = getAdminToken();
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export async function isAdminAuthenticated() {
  const token = getAdminToken();
  if (!token) return false;
  try {
    await adminApi().get("/admin/me");
    return true;
  } catch {
    clearAdminToken();
    return false;
  }
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  return String(detail);
}
